export default __webpack_public_path__ + "static/media/6.a1c51d42.jpg";